//#region import
import React, { Fragment, createContext, useCallback, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDeleteTable, BtnDraft, BtnEdit, BtnEditTable, BtnSave, BtnSend, BtnSendRequest, BtnViewTable } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { RadioListItem } from 'components/Input/Radio';
import AccordionPanel from '../components/AccordionPanel';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import AutoCompleteInTable from 'components/DataGrid/AutoCompleteInTable';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import "../StyleProject.css";
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import ChangeOrderCustom from 'components/System/ChangeOrderCustom';
import { useLocation } from 'react-router';
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Panel8 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    
    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [arrDataTypeIndicatorsID, setarrDataTypeIndicatorsID] = useState<any>([]); //[{ label: "เชิงปริมาณ", value: 1, }, { label: "เชิงคุณภาพ", value: 2 }]  
    const [arrDataFundIndicatorID, setarrDataFundIndicatorID] = useState<any>([]);       

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sResultOutput: null,
            sResultOutcome: null,
            sResultImpactSocial: null,
            sResultImpactEconomic: null,
            sResultImpactEnvironment: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);
    
    useEffect(() => {
        GetFormInitial();      
    }, []);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel8, { nProjectID : nProjectID }, (result) => { 
            setarrDataTypeIndicatorsID(result.lstIndicatorsTypeID);
            setarrDataFundIndicatorID(result.lstFundIndicatorID);
            // handleGetTableProject(dataRow);
        });
    }

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel8, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);

            setarrProjectIndicators(result.objResult.lstProjectIndicator);
            form.setValue("sResultOutput", result.objResult.sResultOutput);
            form.setValue("sResultOutcome", result.objResult.sResultOutcome);
            form.setValue("sResultImpactSocial", result.objResult.sResultImpactSocial);
            form.setValue("sResultImpactEconomic", result.objResult.sResultImpactEconomic);
            form.setValue("sResultImpactEnvironment", result.objResult.sResultImpactEnvironment);
        });
    };

    //#region Indicators
    const [nIndicatorsIDEdit, setnIndicatorsIDEdit] = useState(0);
    const [ObjIndicatorsIDEdit, setObjIndicatorsIDEdit] = useState(null);
    const [arrProjectIndicators, setarrProjectIndicators] = useState([]);

    const formIndicators = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {            
            nIndicatorTypeID: 91, // 91 เชิงปริมาณ | 92 เชิงคุณภาพ
            sIndicator: null,
            sCriteria: null,
            arrFundIndicatorID: null,
        } as any,
    });

    const handleChangeOrder = (nNewOrder, nOldOrder, nIndicatorTypeID) => {
        let arrRowPlanAll = arrProjectIndicators.filter(f=> f.nIndicatorTypeID !== nIndicatorTypeID);
        let arrRowPlan = arrProjectIndicators.filter(f=> f.nIndicatorTypeID === nIndicatorTypeID);
        let objSelf = arrRowPlan.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowPlan.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowPlan.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowPlan = arrRowPlan.slice().sort((a, b) => a.nOrder - b.nOrder);
        setarrProjectIndicators([...arrRowPlan, ...arrRowPlanAll]);
    };

    const onAddIndicators = () => {
        let oFormIndicators = formIndicators.getValues();
        let nIndicatorTypeID = Convert.StringToInt(oFormIndicators.nIndicatorTypeID);
        let ObjDuplicate = arrProjectIndicators.filter((f) => !f.isDelete && (nIndicatorsIDEdit !== 0 ? f.nID !== nIndicatorsIDEdit : true) && f.nIndicatorTypeID === nIndicatorTypeID && f.sIndicator === oFormIndicators.sIndicator);
        if ((ObjDuplicate || []).length === 0)
        {      
            let nIndicatorsID = 0;
            let arrIndicators = DefaultArrayEmpty(arrProjectIndicators);
            let nMaxID = new LINQ<any>(arrIndicators).Any() ? new LINQ<any>(arrIndicators).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrIndicators).Where(w=> w.nIndicatorTypeID === nIndicatorTypeID).Any() ? new LINQ<any>(arrIndicators).Where(w=> w.nIndicatorTypeID === nIndicatorTypeID).Max((m) => m.nOrder) + 1 : 1;
            if (nIndicatorsIDEdit) {
                arrIndicators = arrIndicators.filter((f) => f.nID !== nIndicatorsIDEdit);
                nMaxID = nIndicatorsIDEdit;
                let ObjIndicators = arrProjectIndicators.find((f) => f.nID === nIndicatorsIDEdit);
                nIndicatorsID = ObjIndicators?.nIndicatorsID;
                if (nIndicatorTypeID === ObjIndicators?.nIndicatorTypeID) nOrder = ObjIndicators?.nOrder; //ถ้ายังเท่ากับประเภทเดิมให้อยู่ลำดับเดิม
            }
            let obj = {
                isDelete: false,
                isEdit: false, 
                sID: nMaxID.toString(),
                nID: nMaxID,
                nIndicatorsID: nIndicatorsID,
                nIndicatorTypeID: nIndicatorTypeID,
                sIndicator: oFormIndicators.sIndicator,
                sCriteria: oFormIndicators.sCriteria,
                arrFundIndicatorID: oFormIndicators.arrFundIndicatorID ? (oFormIndicators.arrFundIndicatorID || []).map(nFormIndicatorsID => Convert.StringToInt(nFormIndicatorsID)) : [],
                nOrder: nOrder,
            };
            let result = [...arrIndicators, obj];
            let arrTable = new LINQ<any>(result || []).Where(w=> !w.isDelete).OrderBy(o => o.nIndicatorTypeID).ThenBy(o=> o.nOrder).ToArray();

            //#region กรณี เปลี่ยนประเภทเลย ลำดับเลขต้องเรีบงใหม่
            arrDataTypeIndicatorsID.forEach(iType => {
                let nOrderType = 1;
                arrTable.filter(f => f.nIndicatorTypeID === iType.value).forEach(iIndicators => {
                    iIndicators.nOrder = nOrderType++;
                });
            });     
            //#endregion

            setarrProjectIndicators(arrTable);
            setnIndicatorsIDEdit(0);
            setObjIndicatorsIDEdit(null);
            onClearFieldIndicators();
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldIndicators = () => {
        let nIndicatorTypeID = Convert.StringToInt(formIndicators.getValues("nIndicatorTypeID"));
        Object.keys(formIndicators.getValues()).forEach((key) => {
            formIndicators.setValue(key, null);
            formIndicators.clearErrors(key);
        });
        // formIndicators.setValue("nIndicatorTypeID", 91); // 91 เชิงปริมาณ | 92 เชิงคุณภาพ
        formIndicators.setValue("nIndicatorTypeID", nIndicatorTypeID); //ซึ่งต้องค้างอยู่ที่หัวข้อปัจจุบันที่เคยทำการบันทึก
    };

    const onEditIndicators = (ObjData, nModeID : EnumStatusMode) => {
        setnIndicatorsIDEdit(ObjData.nID);   
        let ObjIndicators = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nID: ObjData.nID,
            nIndicatorsID: ObjData.nIndicatorsID,  
            nIndicatorTypeID: ObjData.nIndicatorTypeID,
            sIndicator: ObjData.sIndicator,
            sCriteria: ObjData.sCriteria,
            arrFundIndicatorID: ObjData.arrFundIndicatorID,
            nOrder: ObjData.nOrder,                
        };
        setObjIndicatorsIDEdit(ObjIndicators);
        formIndicators.setValue("nIndicatorTypeID", ObjIndicators.nIndicatorTypeID);
        formIndicators.setValue("sIndicator", ObjIndicators.sIndicator);
        formIndicators.setValue("sCriteria", ObjIndicators.sCriteria);
        formIndicators.setValue("arrFundIndicatorID", ObjIndicators.arrFundIndicatorID);  
        
        document.getElementById("myDivIndicators").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteIndicators = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrIndicatorsData: any[] = arrProjectIndicators;
            let result = arrIndicatorsData.filter((f) => f.nID !== nID);
            let arrDelete = arrIndicatorsData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })
            //เรียง Order ใหม่
            let nOrder = 1;
            // result.filter(f => !f.isDelete).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => { f.nOrder = nOrder++; });            

            result.filter(f => !f.isDelete && arrDelete.map(m=> m.nIndicatorTypeID).includes(f.nIndicatorTypeID)).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => { f.nOrder = nOrder++; });            
            // let dddresult = new LINQ<any>(result || []).Where(w=> !w.isDelete).OrderBy(o=> o.nIndicatorTypeID).ThenBy(o=> o.nOrder).ToArray();

            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setarrProjectIndicators([...result, ...arrDelete]);
        });
    };
    
    const CallTableIndicators = useCallback(() => {
        let arrIndicatorsType = arrDataTypeIndicatorsID;
        let lstDataIndicators = arrProjectIndicators.filter(f => !f.isDelete) ?? [];
        let lstDataIndicatorType = new LINQ<any>(arrIndicatorsType).Where(w=> lstDataIndicators.map(m=> m.nIndicatorTypeID).includes(w.value)).Distinct().ToArray() ?? [];

        return (
            <TableContainer id='table-indicators' component={Paper}>
                <Table sx={{ minWidth: 800 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '95px', width: '95px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '100px', width: '100px' }}>ตัวชี้วัดที่</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '400px', width: '400px' }}>ตัวชี้วัด</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>เกณฑ์การประเมิน</TableCell>
                        </TableRow>
                    </TableHead>                   
                        {lstDataIndicatorType.map((iType) => {
                            return (
                                <TableBody>
                                    <TableRow key={`sID_Plan_${iType.value}`}>
                                        <TableCell className='bg-color' colSpan={4} align="left">{"ตัวชี้วัด " + iType.label}</TableCell>
                                    </TableRow>
                                    {lstDataIndicators.filter(f=> f.nIndicatorTypeID === iType.value).map((iIndicators) => {
                                        let lstnOrder = new LINQ<any>(lstDataIndicators).Where(w=> w.nOrder !== 0 && w.nIndicatorTypeID === iIndicators.nIndicatorTypeID).OrderBy(o=> o.value).Select(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}).ToArray();
                                        return (
                                            <TableRow key={`sID_Indicators_${iIndicators.sID}`}>
                                                <TableCell align="center">
                                                    {(!iIndicators.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                        <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iIndicators.nID}`}>
                                                            <Grid item>
                                                                <BtnDeleteTable
                                                                    key={"btnDelete_Indicators_" + iIndicators.nID}
                                                                    id={"btnDelete_Indicators_" + iIndicators.nID}
                                                                    onClick={() => onDeleteIndicators(iIndicators.nID, EnumStatusMode.Delete)}
                                                                    IsDisabled={!isPermission || isEditSecretary === false}
                                                                    IsCircleWithOutText={true}
                                                                />   
                                                            </Grid>   
                                                            <Grid item>
                                                                <BtnEditTable
                                                                    key={"btnEdit_Indicators_" + iIndicators.nID}
                                                                    id={"btnEdit_Indicators_" + iIndicators.nID}
                                                                    onClick={() => onEditIndicators(iIndicators, EnumStatusMode.Edit)}
                                                                    IsDisabled={!isPermission || isEditSecretary === false}
                                                                    IsCircleWithOutText={true}
                                                                />
                                                            </Grid>                                                           
                                                        </Grid>
                                                        :
                                                        <BtnViewTable
                                                            key={"btnPreview_Indicators_" + iIndicators.nID}
                                                            id={"btnPreview_Indicators_" + iIndicators.nID}
                                                            onClick={() => onEditIndicators(iIndicators, EnumStatusMode.View)}
                                                            // IsDisabled={isPermission || isEditSecretary === false}
                                                            IsCircleWithOutText={true}
                                                        />
                                                    }
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12} key={"nOrder_Indicators_" + iIndicators.sID}>
                                                        {/* <AutoCompleteInTable
                                                            key={"Indicators_nOrder_" + iIndicators.sID}
                                                            small
                                                            fullWidth={true}
                                                            objValue={{label: iIndicators.nOrder, value: iIndicators.nOrder}}
                                                            funcOnChange={(newValue: any) => {
                                                                handleChangeOrder(newValue.target.innerText, iIndicators.nOrder, iIndicators.nIndicatorTypeID);
                                                            }}
                                                            lstOption={lstnOrder ?? []}
                                                            disClearable={true}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        /> */}
                                                        <ChangeOrderCustom
                                                            id={"Indicators_nOrder_" + iIndicators.sID}
                                                            item={iIndicators}
                                                            value={iIndicators.nOrder}
                                                            onChangeOrder={(sID, nOrder) =>
                                                                handleChangeOrder(+nOrder, +iIndicators.nOrder, iIndicators.nIndicatorTypeID)
                                                            }
                                                            optOrder={lstnOrder ?? []}
                                                            IsView={false}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        />
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iIndicators.sIndicator ?? "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iIndicators.sCriteria ?? "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}    
                                </TableBody>
                            )})
                        }
                        {lstDataIndicatorType.length === 0 ?
                            <StyledTableRow key={`sID_Indicators`}>
                                <TableCell align="center" colSpan={4}>ไม่พบข้อมูล</TableCell>
                            </StyledTableRow>
                            :
                            null
                        }                    
                </Table>
            </TableContainer>
            // <BtnViewTable
            //     key={"btnPreview_" + iIndicators.nID}
            //     id={"btnPreview_" + iIndicators.nID}
            //     onClick={() => onEditIndicators(iIndicators.nID, EnumStatusMode.View)}
            //     // IsDisabled={!isPermission || isEditSecretary === false}
            //     IsCircleWithOutText={true}
            // />
            // <BtnClearTable
            //     key={"btnClear_" + iIndicators.nID}
            //     id={"btnClear_" + iIndicators.nID}
            //     onClick={() => onEditIndicators(iIndicators.nID, EnumStatusMode.View)}
            //     // IsDisabled={!isPermission || isEditSecretary === false}
            //     IsCircleWithOutText={true}
            // />
        );
    }, [arrProjectIndicators, isEditSecretary]);
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let ObjData = form.getValues();        
        if ((ObjData.sResultImpactSocial === null && ObjData.sResultImpactEconomic === null && ObjData.sResultImpactEnvironment === null) && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณากรอกข้อมูลหัวข้อ 8.2.3 ผลกระทบ (Impact) อย่างน้อย 1 หัวข้อ");
        } 
        if ((arrProjectIndicators.filter(f => !f.isDelete && f.nIndicatorTypeID === 91).length === 0) && nModeID === EnumSaveModeProject.Submit) { 
            // 91 เชิงปริมาณ | 92 เชิงคุณภาพ
            //เชิงปริมาณ ต้องมีเสมอ และอย่างน้อย 1 รายการ
            return DialogFn.Warning("กรุณาเพิ่มรายการข้อมูล เชิงปริมาณ อย่างน้อย 1 รายการ");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel8,
            isFastTrack: isFastTrack,

            lstProjectIndicator: arrProjectIndicators,
            sResultOutput: ObjData.sResultOutput,
            sResultOutcome: ObjData.sResultOutcome,
            sResultImpactSocial: ObjData.sResultImpactSocial,
            sResultImpactEconomic: ObjData.sResultImpactEconomic,
            sResultImpactEnvironment: ObjData.sResultImpactEnvironment,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel8, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 8, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };
    
    const onClearField = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
    };

    return (
        <AccordionPanel
            header={"8. ตัวชี้วัดความสำเร็จและผลการดำเนินงานโครงการ"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        > 
            <Grid id={"myDivPanel8"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={2}>
                    {/* <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item>
                            <Typography variant='h6' color={'#0000a5'}>8.1 ตัวชี้วัดความสำเร็จโครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Tooltip placement={'right-end'} title={"เกณฑ์การประเมินความสำเร็จของโครงการในภาพรวม แบ่งเป็นตัวชี้วัดเชิงปริมาณและตัวชี้วัดเชิงคุณภาพ"}>
                                <ErrorIcon color='primary'/>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider />
                        </Grid>
                    </Grid>*/}
                    <Grid id={"myDivIndicators"} item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"8.1 ตัวชี้วัดความสำเร็จโครงการ"} //กำหนดแผนงาน
                            isExpanded={false} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                            SubHeaderStatus={
                                <Tooltip placement={'right-end'} title={"เกณฑ์การประเมินความสำเร็จของโครงการในภาพรวม แบ่งเป็นตัวชี้วัดเชิงปริมาณและตัวชี้วัดเชิงคุณภาพ"}>
                                    <ErrorIcon color='inherit'/>
                                </Tooltip>
                            }
                            sStyleSubHeader={"start"}
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formIndicators}>
                                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={12}>
                                            <RadioListItem
                                                id={"nIndicatorTypeID"}
                                                name={"nIndicatorTypeID"}
                                                label={"ประเภทตัวชี้วัด"}
                                                IsNotShowLabel={true}
                                                required={true}
                                                options={arrDataTypeIndicatorsID}    
                                                disabled={!isPermission || isEditSecretary === false}  
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sIndicator"}
                                                name={"sIndicator"}
                                                type={"text"}
                                                label={"ชื่อตัวชี้วัด"}
                                                required={true}
                                                maxLength={500}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid> 
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sCriteria"}
                                                name={"sCriteria"}
                                                label={"เกณฑ์การประเมิน"}                               
                                                required={true}
                                                maxLength={500}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>     
                                        <Grid item xs={12} md={12} style={{ display: 'none'}}>
                                            {/* ในอนาคตทางกองทุนฯจะมีตัวชี้วัดกลางที่บังคับให้ผู้ขอทุนเข้ามากรอก ต้องการให้ทีมพัฒนาระบบออกแบบ DB เผื่อในส่วนนี้ไว้ ใน Phase นี้ Hide Field ไว้ก่อน */}
                                            {/* <SelectItem
                                                id="arrFundIndicatorID"
                                                name={"arrFundIndicatorID"}
                                                label={"ตัวชี้วัด (กองทุน)"}
                                                options={arrFundIndicatorID}
                                                required={false}
                                                disabled={!isPermission || isEditSecretary === false}
                                            /> */}
                                            <MultipleSelectItem
                                                id="arrFundIndicatorID"
                                                name={"arrFundIndicatorID"}
                                                label={"ตัวชี้วัด (กองทุน)"}
                                                required={false}
                                                options={arrDataFundIndicatorID}                                              
                                                limitTag={1}                 
                                                disabled={!isPermission || isEditSecretary === false}  
                                            />
                                        </Grid>  
                                    </Grid>                                       
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end" style={{ paddingBottom: '2%', }}>
                                        {(nIndicatorsIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_Indicators"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มกิจกรรม"} onClick={formIndicators.handleSubmit((e) => onAddIndicators(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Indicators"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formIndicators.handleSubmit((e) => onAddIndicators(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nIndicatorsIDEdit !== 0 &&
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_Indicators"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnIndicatorsIDEdit(0); setObjIndicatorsIDEdit(null); onClearFieldIndicators(); }} />
                                                    </Grid>
                                                }             
                                            </>
                                        }
                                    </Grid>  
                                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                                        <CallTableIndicators />
                                    </Grid>   
                                </FormProvider>                                    
                            </Grid>  
                        </AccordionPanel>  
                    </Grid>       
                    <FormProvider {...form}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <AccordionPanel
                                header={"8.2 ผลการดำเนินงานโครงการ"}
                                isExpanded={false} 
                                color="white"
                                bgColor="rgb(102,151,245)"
                                background="#e79a09"
                                expandIconColor="white"
                                borderColor="1px solid #e79a09"
                                borderRadius="20px !important"
                                boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                            >        
                                <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item>
                                                <Typography variant='body1'>8.2.1 ผลผลิต (Output)</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body1' color={'red'}>*</Typography>                                                    
                                            </Grid>                                                
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sResultOutput"}
                                                name={"sResultOutput"}
                                                label={""}                        
                                                placeholder={"ผลที่เกิดขึ้นทันทีหรือที่เกิดขึ้นโดยตรงหลังจากการดําเนินโครงการ/กิจกรรมเสร็จสิ้น โดยให้ระบุผลผลิตทั้งในเชิงปริมาณและเชิงคุณภาพ"}       
                                                required={true}
                                                maxLength={2000}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item>
                                                <Typography variant='body1'>8.2.2 ผลลัพธ์ (Outcome)</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body1' color={'red'}>*</Typography>                                                    
                                            </Grid>                                                
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sResultOutcome"}
                                                name={"sResultOutcome"}
                                                label={""}                        
                                                placeholder={"ผลที่ได้รับจากการใช้ประโยชน์ผลผลิตของโครงการ รวมถึงประโยชน์ที่เกิดขึ้นจากการใช้ผลผลิตของโครงการโดยกลุ่มเป้าหมาย"}       
                                                required={true}
                                                maxLength={2000}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item>
                                                <Typography variant='body1'>8.2.3 ผลกระทบ (Impact)</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body1' color={'red'}>กรุณาระบุอย่างน้อย 1 หัวข้อ</Typography>                                                    
                                            </Grid>                                                
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body1' style={{textDecoration: 'underline'}} >ผลกระทบ (ต่อสังคม)</Typography>                             
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <TextAreaItem
                                                        id={"sResultImpactSocial"}
                                                        name={"sResultImpactSocial"}
                                                        label={""}                        
                                                        placeholder={"ผลสืบเนื่องเชิงบวกจากการดําเนินงานโครงการ ทั้งที่เกิดขึ้นระหว่างและภายหลังการดําเนินงานโครงการที่อาจกระทบต่อการพัฒนาในมิติอื่นหรือการปฏิบัติภารกิจของหน่วยงาน/ประชาชนทั้งที่เป็นกลุ่มเป้าหมายและกลุ่มอื่นทั้งภายในและภายนอกพื้นที่ ครอบคลุมถึงผลกระทบทั้งทางตรงและทางอ้อมในทุกมิติ (สังคม เศรษฐกิจ และสิ่งแวดล้อม) ทั้งที่สามารถประเมินในรูปตัวเงินและไม่ใช่ตัวเงิน"}       
                                                        required={false}
                                                        maxLength={2000}
                                                        row={3}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body1' style={{textDecoration: 'underline'}} >ผลกระทบ (ต่อเศรษฐกิจ)</Typography>                             
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <TextAreaItem
                                                        id={"sResultImpactEconomic"}
                                                        name={"sResultImpactEconomic"}
                                                        label={""}                        
                                                        placeholder={"ผลสืบเนื่องเชิงบวกจากการดําเนินงานโครงการ ทั้งที่เกิดขึ้นระหว่างและภายหลังการดําเนินงานโครงการที่อาจกระทบต่อการพัฒนาในมิติอื่นหรือการปฏิบัติภารกิจของหน่วยงาน/ประชาชนทั้งที่เป็นกลุ่มเป้าหมายและกลุ่มอื่นทั้งภายในและภายนอกพื้นที่ ครอบคลุมถึงผลกระทบทั้งทางตรงและทางอ้อมในทุกมิติ (สังคม เศรษฐกิจ และสิ่งแวดล้อม) ทั้งที่สามารถประเมินในรูปตัวเงินและไม่ใช่ตัวเงิน"}       
                                                        required={false}
                                                        maxLength={2000}
                                                        row={3}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body1' style={{textDecoration: 'underline'}}>ผลกระทบ (ต่อสิ่งแวดล้อม)</Typography>                             
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <TextAreaItem
                                                        id={"sResultImpactEnvironment"}
                                                        name={"sResultImpactEnvironment"}
                                                        label={""}                        
                                                        placeholder={"ผลสืบเนื่องเชิงบวกจากการดําเนินงานโครงการ ทั้งที่เกิดขึ้นระหว่างและภายหลังการดําเนินงานโครงการที่อาจกระทบต่อการพัฒนาในมิติอื่นหรือการปฏิบัติภารกิจของหน่วยงาน/ประชาชนทั้งที่เป็นกลุ่มเป้าหมายและกลุ่มอื่นทั้งภายในและภายนอกพื้นที่ ครอบคลุมถึงผลกระทบทั้งทางตรงและทางอ้อมในทุกมิติ (สังคม เศรษฐกิจ และสิ่งแวดล้อม) ทั้งที่สามารถประเมินในรูปตัวเงินและไม่ใช่ตัวเงิน"}       
                                                        required={false}
                                                        maxLength={2000}
                                                        row={3}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>   
                                </Grid>  
                            </AccordionPanel>                            
                        </Grid> 
                        {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                            <></>
                            :     
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end" style={{ paddingBottom: '1%', }}>
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel8"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel8"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))}/>
                                        </Grid> 
                                    </Grid>   
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel8"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel8").scrollIntoView({ behavior: "smooth" });}} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel8"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel8"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }
                    </FormProvider>     
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1'>หมายเหตุ</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            <Grid item xs={12} md={11.8}>
                                <Grid item>
                                    <Typography variant='body2'>{"กําหนดให้โครงการตามมาตรา ๔๐ (๓) ต้องระบุผลลัพธ์ ๓ เรื่อง ดังนี้"}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>{"๑) การจัดทําบัญชีซากดึกดําบรรพ์ที่เป็นผลผลิตของโครงการ ตามคู่มือมาตรฐานการจัดทําบัญชีซากดึกดําบรรพ์ (กรมทรัพยากรธรณี, ๒๕๖๖) โดยสามารถ Download ไฟล์คู่มือดังกล่าวได้ที่เว็บไซต์กองทุนจัดการซากดึกดําบรรพ์ (https://www.dmr.go.th/Fossil_Management_Fund/)"}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>{"๒) การเผยแพร่ผลงานโครงการในการประชุมหรือวารสารวิชาการในระดับชาติและ/หรือระดับนานาชาติอย่างน้อย ๑ เรื่อง"}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2'>{"๓) กิจกรรมการเผยแพร่/ประชาสัมพันธ์องค์ความรู้ที่ได้รับจากการดําเนินงานสู่ประชาชน และ/หรือสถาบันการศึกษาในพื้นที่แหล่งซากดึกดําบรรพ์อย่างน้อย ๑ ครั้ง"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>                    
                </Grid>  
            </Grid>
        </AccordionPanel>
    )
}
export default Panel8;
